import { render, staticRenderFns } from "./EditPatientData.vue?vue&type=template&id=7bab2598&scoped=true&"
import script from "./EditPatientData.vue?vue&type=script&lang=js&"
export * from "./EditPatientData.vue?vue&type=script&lang=js&"
import style0 from "./EditPatientData.vue?vue&type=style&index=0&id=7bab2598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bab2598",
  null
  
)

export default component.exports